/**
 * 重要通知顶部横幅
 * @author ritaxxu
 */
import React from 'react'
import { Button } from 'antd'
import { useShallow } from 'zustand/react/shallow'
import { notificationStore } from '@store'
import './index.less'

const NotificationBanner: React.FC = () => {
  const { bannerVisible, unreadCount, hideBanner, togglePanel } = notificationStore(
    useShallow((s) => ({
      bannerVisible: s.bannerVisible,
      unreadCount: s.unreadCount,
      hideBanner: s.hideBanner,
      togglePanel: s.togglePanel,
    })),
  )

  if (!bannerVisible || unreadCount.importantUnreadCount === 0) return null

  const handleView = () => {
    hideBanner()
    togglePanel()
  }

  return (
    <div className="notification-banner">
      <span className="notification-banner-icon">📌</span>
      <span className="notification-banner-text">
        你有 {unreadCount.importantUnreadCount} 条重要通知未读
      </span>
      <Button type="primary" size="small" onClick={handleView}>
        立即查看
      </Button>
      <Button size="small" onClick={hideBanner} style={{ marginLeft: 8 }}>
        稍后再说
      </Button>
    </div>
  )
}

export default NotificationBanner
